import React,{ useState, useEffect, useContext } from 'react';
import MaterialTable from 'material-table';
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import {
  language
} from 'config';
import { FirebaseContext } from 'common';

export default function Locations() {
  const { api } = useContext(FirebaseContext);
  const {
    editLocation,
  } = api;
  const [data, setData] = useState([]);
  const locationdata = useSelector(state => state.locationdata);
  const dispatch = useDispatch();

  useEffect(()=>{
    if(locationdata.locations){
      setData(locationdata.locations);
    }else{
      setData([]);
    }
  },[locationdata.locations]);


  const columns = [
      { 
        title: language.locationName, 
        field: 'locationName',
        render: rowData => <span style={{width: 300}}>{rowData.locationName}</span>
      }
  ];

  return (
    locationdata.loading? <CircularLoading/>:
    <MaterialTable
      title={language.locations}
      columns={columns}
      data={data}
      options={{
        exportButton: true,
        sorting: true,
      }}
      editable={{
        onRowAdd: newData =>
        new Promise(resolve => {
          setTimeout(() => {
              dispatch(editLocation(newData,"Add"));
              resolve();
          }, 600);
        }),
        onRowUpdate: (newData, oldData) =>
          new Promise(resolve => {
            setTimeout(() => {
              resolve();
              console.log(oldData.id,newData);
              dispatch(editLocation(newData,"Update"));
            }, 600);
          }),
        onRowDelete: oldData =>
          new Promise(resolve => {
            setTimeout(() => {
              resolve();
              dispatch(editLocation(oldData,"Delete"));
            }, 600);
          }),
      }}
    />
  );
}
